import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'
import Icon from '../../atoms/Icon'
import { useStatusIcon } from '../../../api/groups'

const useStyles = makeStyles((theme) => ({
  statusDisplay: ({ status, size }) => ({
    background: status?.color
      ? status.color
      : 'inherit',
    width: `${size}px`,
    height: `${size}px`,
    display: 'inline-block',
    borderRadius: 'var(--border-radius-round)',
    borderWidth: status?.color ? '1px' : undefined,
    borderStyle: status?.color ? 'solid' : undefined,
    borderColor: status?.color ? status.color : undefined
  }),
  statusIcon: ({ status, size }) => {
    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 'var(--border-radius-md)',
      backgroundColor: status?.color ? `color-mix(in srgb, ${status.color} 30%, white)` : undefined,
      width: `${size + 10}px`,
      height: `${size + 10}px`,
      padding: '5px',
      '& svg': {
        fill: status?.color,
        stroke: status?.color
      }
    }
  },
  statusImage: ({ size }) => ({
    width: `${size}px`,
    height: `${size}px`,
    objectFit: 'contain',
    display: 'block'
  }),
  statusImageWrapper: ({ status, size, hasBackground }) => ({
    width: `${size + 10}px`,
    height: `${size + 10}px`,
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'var(--border-radius-md)',
    backgroundColor: hasBackground && status?.color ? `color-mix(in srgb, ${status.color} 30%, white)` : undefined,
    position: 'relative'
  })
}))

function StatusReportStatusIcon ({ status, size, useIcon, hasBackground }) {
  const classes = useStyles({ status, size, hasBackground })
  const { data: customImage, isFetching } = useStatusIcon(status?.statusId, { enabled: !!status?.statusId })

  if (isFetching) {
    return <CircularProgress size={size} />
  }

  if (customImage?.imageUrl) {
    return (
      <span className={classes.statusImageWrapper} title={status?.displayName}>
        <img
          src={customImage.imageUrl}
          alt={status?.displayName || 'Status icon'}
          className={classes.statusImage}
        />
      </span>
    )
  }

  if (useIcon && status?.icon) {
    return (
      <span className={classes.statusIcon}>
        <Icon
          name={status.icon}
          customSize={size}
          color={status.color}
        />
      </span>
    )
  }

  return (
    <span className={classes.statusDisplay} title={status?.displayName} />
  )
}

StatusReportStatusIcon.propTypes = {
  status: PropTypes.shape({
    codeName: PropTypes.string.isRequired,
    statusId: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    icon: PropTypes.string
  }),
  size: PropTypes.number,
  useIcon: PropTypes.bool,
  hasBackground: PropTypes.bool
}

StatusReportStatusIcon.defaultProps = {
  size: 14,
  useIcon: false,
  hasBackground: false
}

export default StatusReportStatusIcon
